// import React, { useState } from 'react';
// import { Button } from './ui/button';
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogDescription,
// } from './ui/dialog';
// import { Input } from './ui/input';
// import {
//   Edit3,
//   FileText,
//   LayoutDashboard,
//   Briefcase,
//   ArrowRight,
//   CheckCircle2,
// } from 'lucide-react';

// /* -------------------- DATA -------------------- */

// const liveProducts = [
//   {
//     id: 1,
//     name: 'Wriety',
//     description:
//       'Generate, refine, and structure content with intelligent writing assistance.',
//     subtext: 'Create professional content faster',
//     icon: Edit3,
//     status: 'live',
//     brochureUrl:
//       'https://customer-assets.emergentagent.com/job_thinkcraft-2/artifacts/w1x5dwxr_Advanced%20Brochur.pdf',
//     specSheetUrl:
//       'https://customer-assets.emergentagent.com/job_thinkcraft-2/artifacts/jlq3d7k2_Advanced%20Specs.pdf',
//   },
//   {
//     id: 2,
//     name: 'Wriety API',
//     description:
//       "Integrate Wriety's AI capabilities directly into your applications and workflows.",
//     subtext: 'Build on enterprise-grade AI infrastructure',
//     icon: Edit3,
//     status: 'live',
//     brochureUrl:
//       'https://customer-assets.emergentagent.com/job_thinkcraft-2/artifacts/7x40m4s7_AI%20API%20Broucher.pdf',
//     specSheetUrl:
//       'https://customer-assets.emergentagent.com/job_thinkcraft-2/artifacts/oe28j7zg_AI%20API%20Specs.pdf',
//   },
// ];

// const comingSoonProducts = [
//   {
//     id: 3,
//     name: 'Note Taking AI',
//     description:
//       'Capture, summarize, and retrieve information with AI-powered organization.',
//     subtext: 'Keep every important idea within reach',
//     icon: FileText,
//     status: 'coming-soon',
//   },
//   {
//     id: 4,
//     name: 'Productivity Board',
//     description:
//       'Manage tasks, ideas, and workflows with intelligent automation.',
//     subtext: 'Stay organized without the overhead',
//     icon: LayoutDashboard,
//     status: 'coming-soon',
//   },
//   {
//     id: 5,
//     name: 'AI Appliance for SMBs',
//     description:
//       'Automate everyday business operations with purpose-built AI solutions.',
//     subtext: 'Enterprise-grade tools at SMB-friendly pricing',
//     icon: Briefcase,
//     status: 'coming-soon',
//   },
// ];

// /* -------------------- COMPONENT -------------------- */

// export default function ProductsSection() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [email, setEmail] = useState('');
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleProductClick = (product) => {
//     if (product.status === 'coming-soon') {
//       setSelectedProduct(product);
//       setIsModalOpen(true);
//       setEmail('');
//       setIsSubmitted(false);
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setTimeout(() => {
//       setSelectedProduct(null);
//       setEmail('');
//       setIsSubmitted(false);
//     }, 200);
//   };

//   const handleSubmitWaitlist = async (e) => {
//     e.preventDefault();
//     if (!email.includes('@')) return;
//     setIsSubmitting(true);
//     await new Promise((r) => setTimeout(r, 1000));
//     setIsSubmitting(false);
//     setIsSubmitted(true);
//   };

//   /* -------------------- CARD -------------------- */

//   const renderProductCard = (product, index) => {
//     const Icon = product.icon;
//     const isLive = product.status === 'live';

//     return (
//       <div
//         key={product.id}
//         onClick={() => handleProductClick(product)}
//         className={`group relative flex flex-col h-full bg-white rounded-lg cursor-pointer
//           border border-gray-200
//           transition-all duration-500
//           hover:-translate-y-1
//           ${isLive ? 'hover:shadow-lg' : 'hover:shadow-md'}
//           animate-stagger-${index}`}
//         style={{ animationDelay: `${index * 0.1}s` }}
//       >
//         {/* Bottom hover indicator */}
//         <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-[6px] bg-gray-900 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-center rounded-b-lg" />

//         {/* Content */}
//         <div className="flex-grow px-12 py-16">
//           <div
//             className={`inline-flex items-center justify-center w-12 h-12 rounded-full mb-8 transition-all duration-500 ${
//               isLive
//                 ? 'bg-gray-900 text-white group-hover:scale-105'
//                 : 'bg-gray-100 text-gray-700 group-hover:bg-gray-900 group-hover:text-white group-hover:scale-105'
//             }`}
//           >
//             <Icon className="w-6 h-6" strokeWidth={1.5} />
//           </div>

//           <h3 className="text-3xl font-light tracking-tight text-gray-900 mb-2">
//             {product.name}
//           </h3>

//           <p
//             className={`text-xs uppercase tracking-wide mb-6 ${
//               isLive ? 'text-gray-900' : 'text-amber-700'
//             }`}
//           >
//             {isLive ? 'Available Now' : 'Coming Soon'}
//           </p>

//           <p className="text-base leading-relaxed text-gray-600 mb-4">
//             {product.description}
//           </p>
//           <p className="text-sm font-light text-gray-500">
//             {product.subtext}
//           </p>
//         </div>

//         {/* Separator */}
//         <div className="mx-12 border-t border-gray-100" />

//         {/* CTA */}
//         <div className="px-12 pt-8 pb-16">
//           {isLive && (
//             <div className="flex flex-col sm:flex-row gap-3">
//               <Button
//                 variant="outline"
//                 size="sm"
//                 className="flex-1"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   window.open(product.brochureUrl, '_blank');
//                 }}
//               >
//                 View Brochure
//               </Button>
//               <Button
//                 variant="outline"
//                 size="sm"
//                 className="flex-1"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   window.open(product.specSheetUrl, '_blank');
//                 }}
//               >
//                 View Specs
//               </Button>
//             </div>
//           )}

//           {!isLive && (
//             <div className="flex items-center justify-between text-sm text-gray-600 group-hover:text-gray-900 transition-colors">
//               <span>Join waitlist</span>
//               <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   /* -------------------- JSX -------------------- */

//   return (
//     <>
//       <section id="products" className="py-32 px-6 lg:px-12 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-20">
//             <h2 className="text-5xl lg:text-6xl font-light tracking-tight text-gray-900 mb-6">
//               Products
//             </h2>
//             <p className="text-lg text-gray-600 font-light max-w-2xl mx-auto">
//               A suite of AI-powered tools designed to work together.
//             </p>
//           </div>

//           {/* Live products */}
//           <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mb-8 items-stretch">
//             {liveProducts.map((p, i) => (
//               <div key={p.id} className="md:col-span-3 h-full">
//                 {renderProductCard(p, i)}
//               </div>
//             ))}
//           </div>

//           {/* Coming soon products */}
//           <div className="grid grid-cols-1 md:grid-cols-6 gap-8 items-stretch">
//             {comingSoonProducts.map((p, i) => (
//               <div key={p.id} className="md:col-span-2 h-full">
//                 {renderProductCard(p, i + liveProducts.length)}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Waitlist Modal */}
//       <Dialog open={isModalOpen} onOpenChange={handleCloseModal}>
//         <DialogContent className="sm:max-w-md">
//           {!isSubmitted ? (
//             <>
//               <DialogHeader>
//                 <DialogTitle className="text-2xl font-light tracking-tight">
//                   {selectedProduct?.name}
//                 </DialogTitle>
//                 <DialogDescription>
//                   This product is coming soon. Join the waitlist to be notified when it launches.
//                 </DialogDescription>
//               </DialogHeader>
//               <form onSubmit={handleSubmitWaitlist} className="space-y-4 mt-4">
//                 <Input
//                   type="email"
//                   placeholder="you@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//                 <Button type="submit" className="w-full">
//                   {isSubmitting ? 'Joining…' : 'Join Waitlist'}
//                 </Button>
//               </form>
//             </>
//           ) : (
//             <div className="py-8 text-center">
//               <CheckCircle2 className="w-10 h-10 mx-auto mb-4" />
//               <DialogTitle>You're on the list</DialogTitle>
//               <DialogDescription className="mt-2">
//                 We'll notify you when {selectedProduct?.name} is available.
//               </DialogDescription>
//               <Button onClick={handleCloseModal} className="mt-6">
//                 Close
//               </Button>
//             </div>
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* Animations */}
//       <style jsx>{`
//         @keyframes stagger {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         [class^='animate-stagger-'] {
//           animation: stagger 0.8s ease-out both;
//         }
//       `}</style>
//     </>
//   );
// }






          
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Input } from './ui/input';
import RequestDemoDialog from './tchrr/RequestDemoDialog';
import TrainingSlotDialog from './tchrr/TrainingSlotDialog';
import {
  Edit3,
  FileText,
  LayoutDashboard,
  Briefcase,
  ArrowRight,
  CheckCircle2,
} from 'lucide-react';
import { DEFAULT_REQUEST_DEMO_CALENDLY_URL, DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL } from '../lib/calendly';

/* 🔥 ONLY FIREBASE ADDITION */
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const visualfloLogo = '/Visualflo.svg';
const tchrrLogo = '/Tchrr.svg';
const tchrrWhiteboardAPILogo = '/TchrrWhiteboardAPI.svg';
const konfynLogo = '/Konfyn.svg';

/* -------------------- DATA -------------------- */

const liveProducts = [
  {
    id: 1,
    name: 'Tchrr AI',
    description:
      'Generate, refine, and structure content with intelligent writing assistance.',
    subtext: 'Create professional content faster',
    logoSrc: tchrrLogo,
    status: 'live',
    leftLabel: 'Book a Training Slot',
    rightLabel: 'Request a Demo',
    rightButtonVariant: 'default',
    rightButtonClassName: 'bg-gray-900 text-white hover:bg-gray-800 border-gray-900',
    leftCalendly: {
      title: 'Book a Training Slot',
      description: 'Pick a time that works for you.',
      iframeTitle: 'Calendly training slot booking',  
      src: DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL,
    },
    rightCalendly: {
      title: 'Request a Demo',
      description: 'Pick a time that works for you.',
      iframeTitle: 'Calendly request demo booking',
      src: DEFAULT_REQUEST_DEMO_CALENDLY_URL,
    },
  },
  {
    id: 2,
    name: 'Tchrr AI API',
    description:
      "Integrate Tchrr's AI capabilities directly into your applications and workflows.",
    subtext: 'Build on enterprise-grade AI infrastructure',
    logoSrc: tchrrWhiteboardAPILogo,
    status: 'live',
    brochureUrl:
      'https://drive.google.com/file/d/1vuWCSCGd1ZhQ7u0W98EHiDwgdhexpm8j/view?usp=sharing',
    specSheetUrl:
      'https://drive.google.com/file/d/1cBf-Zb3CZvxQ948eCwwXhCZWuTRekQKe/view?usp=sharing',
  },
];

const comingSoonProducts = [
  {
    id: 3,
    name: 'AI Productivity Board',
    description:
      'An AI collaborative board that is made for IFPDs.',
    subtext: 'Never start with an empty canvas',
    logoSrc: visualfloLogo,
    icon: LayoutDashboard,
    status: 'coming-soon',
  },
  {
    id: 4,
    name: 'AI Appliance for SMEs',
    description:
      'Automate everyday business operations with purpose-built AI solutions.',
    subtext: 'Enterprise-grade tools at SME-friendly pricing',
    logoSrc: konfynLogo,
    status: 'coming-soon',
  },
];

/* -------------------- COMPONENT -------------------- */

export default function ProductsSection() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeCalendlyModal, setActiveCalendlyModal] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleProductClick = (product) => {
    // AI Whiteboard should open the Tchrr landing experience.
    if (product.id === 1) {
      navigate('/tchrr');
      return;
    }

    if (product.status === 'coming-soon') {
      setSelectedProduct(product);
      setIsModalOpen(true);
      setEmail('');
      setIsSubmitted(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setSelectedProduct(null);
      setEmail('');
      setIsSubmitted(false);
    }, 200);
  };

  const openCalendlyRequestDemoModal = (calendlyConfig) => {
    setActiveCalendlyModal({
      title: calendlyConfig?.title || 'Request a Demo',
      description: calendlyConfig?.description || 'Pick a time that works for you.',
      iframeTitle: calendlyConfig?.iframeTitle || 'Calendly booking',
      src: calendlyConfig?.src || DEFAULT_REQUEST_DEMO_CALENDLY_URL,
    });
  };

  const closeCalendlyModal = () => setActiveCalendlyModal(null);

  /* 🔥 ONLY CHANGE: FIREBASE INSTEAD OF FAKE TIMEOUT */
  const handleSubmitWaitlist = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) return;

    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'waitlists'), {
        email: email,
        product: selectedProduct?.name,
        source: 'product_popup',
        createdAt: serverTimestamp(),
      });

      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
      alert('Failed to join waitlist');
    } finally {
      setIsSubmitting(false);
    }
  };

  /* -------------------- CARD -------------------- */

  const renderProductCard = (product, index) => {
    const Icon = product.icon;
    const isLive = product.status === 'live';
    const hasLogo = Boolean(product.logoSrc);

    return (
      <div
        key={product.id}
        onClick={isLive ? () => handleProductClick(product) : undefined}
        className={`group relative flex flex-col h-full bg-white rounded-lg
          border border-gray-200
          transition-all duration-500
          ${isLive ? 'cursor-pointer hover:-translate-y-1 hover:shadow-lg' : 'cursor-default'}
          animate-stagger-${index}`}
        style={{ animationDelay: `${index * 0.1}s` }}
      >
        <div
          className={`pointer-events-none absolute bottom-0 left-0 right-0 h-[6px] bg-gray-900 transition-transform duration-500 origin-center rounded-b-lg ${
            isLive ? 'scale-x-0 group-hover:scale-x-100' : 'scale-x-0'
          }`}
        />

        <div className="flex-grow px-6 py-8 sm:px-10 sm:py-12 lg:px-12 lg:py-16">
          {hasLogo ? (
            <div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 w-full mb-6 sm:mb-8 transition-all duration-500 group-hover:scale-100">
              <img
                src={product.logoSrc}
                alt={`${product.name} logo`}
                className={product.logoSrc === (visualfloLogo) ? 'h-9 w-auto' : 'h-12 w-auto'}
              />
              {!isLive && (
                <div className="self-start sm:self-auto rounded-full bg-gray-100 px-3 sm:px-6 py-1.5 sm:py-2 text-[11px] sm:text-sm font-medium text-gray-600 whitespace-nowrap max-w-full">
                  Coming Soon
                </div>
              )}
            </div>
          ) : (
            <div
              className={`inline-flex items-center justify-center w-12 h-12 rounded-full mb-8 ${
                isLive ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              <Icon className="w-6 h-6" strokeWidth={1.5} />
            </div>
          )}

          <h3 className="text-2xl sm:text-3xl font-light tracking-tight text-gray-900 mb-2">
            {product.name}
          </h3>

          <p className="text-base text-gray-600 mb-4">
            {product.description}
          </p>

          <p className="text-sm text-gray-500">{product.subtext}</p>
        </div>

        <div className="px-6 pt-4 pb-6 sm:px-10 sm:pt-6 sm:pb-8 lg:px-12 lg:pt-8 lg:pb-12">
          {isLive ? (
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                size="lg"
                variant="outline"
                className="w-full sm:flex-1"
                onClick={(e) => {
                  e.stopPropagation();

                  if (product.leftCalendly) {
                    openCalendlyRequestDemoModal(product.leftCalendly);
                    return;
                  }

                  window.open(product.brochureUrl, '_blank');
                }}
              >
                {product.leftLabel || 'View Brochure'}
              </Button>
              <Button
                variant={product.rightButtonVariant || 'outline'}
                size="lg"
                className={`w-full sm:flex-1 ${product.rightButtonClassName || ''}`}
                onClick={(e) => {
                  e.stopPropagation();

                  if (product.rightCalendly) {
                    openCalendlyRequestDemoModal(product.rightCalendly);
                    return;
                  }

                  window.open(product.specSheetUrl, '_blank');
                }}
              >
                {product.rightLabel || 'View Specs'}
              </Button>
            </div>
          ) : (
            <div className="flex items-center justify-between text-sm text-gray-600">
              <Button
                variant="outline"
                height= '36px'
                className="flex-1"
                onClick={(e) => {
                  e.stopPropagation();
                  handleProductClick(product);
                }}
              >
                Join Waitlist
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  };

  /* -------------------- JSX -------------------- */

  return (
    <>
      <section id="products" className="py-14 sm:py-20 lg:py-32 px-4 sm:px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-10 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight text-gray-900 mb-4 sm:mb-6">
            Our Products
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            AI-powered tools designed to work together and with your team.
          </p>
        </div>
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4 sm:gap-8">
            {liveProducts.map((p, i) => (
              <div key={p.id} className="md:col-span-3">
                {renderProductCard(p, i)}
              </div>
            ))}
            {comingSoonProducts.map((p, i) => (
              <div key={p.id} className="md:col-span-3">
                {renderProductCard(p, i + liveProducts.length)}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={isModalOpen} onOpenChange={handleCloseModal}>
        <DialogContent className="sm:max-w-md">
          {!isSubmitted ? (
            <>
              <DialogHeader>
                <DialogTitle>{selectedProduct?.name}</DialogTitle>
                <DialogDescription>
                  This product is coming soon. Join the waitlist to be notified.
                </DialogDescription>
              </DialogHeader>

              <form onSubmit={handleSubmitWaitlist} className="space-y-4 mt-4">
                <Input
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Button type="submit" className="w-full">
                  {isSubmitting ? 'Joining…' : 'Join Waitlist'}
                </Button>
              </form>
            </>
          ) : (
            <div className="py-8 text-center">
              <CheckCircle2 className="w-10 h-10 mx-auto mb-4" />
              <DialogTitle>You're on the list</DialogTitle>
              <Button onClick={handleCloseModal} className="mt-6">
                Close
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <RequestDemoDialog
        open={Boolean(activeCalendlyModal && activeCalendlyModal.src !== DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL)}
        onOpenChange={(open) => !open && closeCalendlyModal()}
        title={activeCalendlyModal?.title || 'Request a Demo'}
        description={activeCalendlyModal?.description || 'Pick a time that works for you.'}
        iframeTitle={activeCalendlyModal?.iframeTitle || 'Calendly booking'}
        src={activeCalendlyModal?.src || DEFAULT_REQUEST_DEMO_CALENDLY_URL}
      />

      <TrainingSlotDialog
        open={Boolean(activeCalendlyModal && activeCalendlyModal.src === DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL)}
        onOpenChange={(open) => !open && closeCalendlyModal()}
        title={activeCalendlyModal?.title || 'Book a Training Slot'}
        description={activeCalendlyModal?.description || 'Pick a training slot that works for you.'}
        iframeTitle={activeCalendlyModal?.iframeTitle || 'Calendly training slot booking'}
        src={activeCalendlyModal?.src || DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL}
      />
    </>
  );
}
